import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentosPorFirmarComponent } from './documentos-por-firmar/documentos-por-firmar.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'documentos-por-firmar',
        component: DocumentosPorFirmarComponent,
        data: {
          title: "Documentos por firmar",
          breadcrumb: "Documentos por firmar"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentosPorFirmarRoutingModule { }
